import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Component({
    selector: "app-input-select",
    templateUrl: "./input-select.component.html",
    styleUrls: ["./input-select.component.css"]
})
export class InputSelectComponent implements OnInit {
    @Output() addChip$ = new EventEmitter<string>();
    @ViewChild("optionsContainer") optionsContainer: ElementRef<HTMLDivElement>;

    private _suggestionsArray = new BehaviorSubject<string[]>([]);
    get suggestionsArray(): string[] {
        return this._suggestionsArray.getValue();
    }

    @Input()
    set suggestionsArray(value) {
        this._suggestionsArray.next(value);
    }

    listArray: string[];
    filteredList = [] as string[];
    isOpen = false;

    ngOnInit() {
        this._suggestionsArray.subscribe(
            x => {
                this.listArray = x;
                this.filteredList = x;
            }
        );
    }

    onFocus() {
        const element = this.optionsContainer.nativeElement;
        if (element.classList.contains("active") === false) {
            element.classList.add("active");
            this.isOpen = true;
        }
    }

    onBlur() {
        const element = this.optionsContainer.nativeElement;

        if (element.classList.contains("active")) {
            element.classList.remove("active");
            this.isOpen = false;
        }
    }

    onFilter(event: KeyboardEvent) {
        const element = event.srcElement as HTMLInputElement;
        let value = element.value;

        if (!value) {
            this.filteredList = this.listArray;
            return;
        }

        value = value.toLowerCase();

        this.filteredList = this.listArray.filter((el: string) => {
            return el.toLowerCase().indexOf(value) !== -1;
        });
    }

    addChip(chipName: string) {
        this.onBlur();
        this.addChip$.emit(chipName);
    }
}
